<template>
    <div class="box1">
        <div class="handle-box-search order">
            <el-row type="flex" justify="start" style="margin-bottom: 20px">
                <div class="order-export-title" style="display: flex">
                    <div class="orHead">历史订单导出</div>
                    <span class="remark"
                        >仅支持导出三个月之前的历史订单，最近三个月的请使用<el-button type="text" @click="orderHis">订单导出</el-button
                        >功能</span
                    >
                </div>
            </el-row>

            <commonExport ref="commonExport" @changeType="changeType" @changeTime="changeTime" @changeYear="changeYear" :history='history'>
                <!-- <template slot="order_year">
                    <span class="title">年份:</span>
                    <div  style="width:350px">
                        <el-button class="year-button"
                        v-for="(item, index) in yearList" :key="index"
                        @click="yearChange(item)" >{{item}}</el-button>

                    </div>



                    <el-tooltip class="item" effect="dark" content="年份按下单时间分割" placement="right">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </template> -->
                <template slot="order_year">
                    <span class="title">年份:</span>

                    <el-select
                        v-model="submit_data.year"
                        placeholder="请选择年"
                        style="width: 350px; margin-right: 20px"
                        @change="yearChange"
                        clearable
                    >
                        <el-option :label="item" :value="item" v-for="(item, index) in yearList" :key="index"> </el-option>
                    </el-select>
                    <el-tooltip class="item" effect="dark" content="年份按下单时间分割" placement="right">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </template>
                <template slot="order_type">
                    <span class="title">订单类型:</span>
                    <el-select
                        v-model="submit_data.type"
                        placeholder="请选择模式"
                        style="width: 350px; margin-right: 20px"
                        @change="typeChange"
                        clearable
                    >
                        <!-- <el-option label="当前订单" value="0"></el-option>
                            <el-option label="历史订单" value="1"></el-option>
                            <el-option label="全部当前订单" value="2"></el-option>
                            <el-option label="全部历史订单" value="3"></el-option>
                            <el-option label="销单订单" value="4"></el-option>
                            <el-option label="历史销单订单" value="5"></el-option> -->
                        <el-option label="全部订单" value="3"></el-option>
                        <el-option label="已支付订单" value="1"></el-option>
                        <el-option label="销单订单" value="5"></el-option>
                        <el-option label="三方无效销单" value="6"></el-option>
                    </el-select>
                </template>
                <template slot="his_type">
                    <span class="title">查询时间:</span>
                    <el-date-picker
                        v-model="search_time"
                        type="datetimerange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        :default-value="default_value"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="timeChange"
                        style="width: 350px"
                        :picker-options="pickerOptions1"
                    >
                    </el-date-picker>
                    <!-- 比如今天是2月9日，那么2月算一个月，所以三个月以内的订单就是从12月1日到当前天的数据，三个月以前的订单就是11月31日以前的订单 -->
                    <span class="remark">仅支持查询三个月前的订单</span>
                </template>
            </commonExport>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { config } from '@/utils/config.js';
import commonExport from './commonExport.vue';

var _this;
export default {
    components: {
        commonExport
    },

    data() {
        return {
            history: 'history',
            yearList: [],
            search_time: '',

            default_value: '',

            dataForm: {
                createDateScopeStart: '',
                createDateDateScopeEnd: ''
            },
            pickerOptions1: {
                // disabledDate(time) {
                //     var thatDay = time.getTime();
                //     // console.log('--------');

                //     // _this.default_value = new Date(threeMonths)

                //     // 图形中显示的每一天 > 当前日期  || 图形中显示的每一天 < 三个月之前的日期
                //     // return thatDay > Date.now() || thatDay < threeMonths;

                //     return thatDay >= _this.computingTime();
                // }
            },
            submit_data: {
                fixed_array: '',
                type: '',
                year: ''
            }
        };
    },
    created() {
        _this = this;
        //设置查询时间的默认时间，比如现在是2023年2月，三个月前的数据可查询，则时间控件打开的时候，显示可选时间范围为2022年11月30日以前的可选
        _this.default_value = new Date(_this.computingTime());
        _this.getYear();
    },

    methods: {
        getYear() {

            // axios.defaults.baseURL = config.axios_normalURL; //请求normal url
            _this
                .$post('/home/historyYear', {}, {}, 'normal')
                .then((res) => {
                    _this.yearList = res.data;
                    // axios.defaults.baseURL = config.axios_baseURL; //请求base url
                })
                .catch((err) => {});
            // axios.defaults.baseURL = config.axios_baseURL; //请求base url
        },
        changeTime() {
            _this.search_time = '';
        },
        changeType() {
            _this.submit_data.type = '';
        },
        changeYear() {
            _this.submit_data.year = '';
        },
        computingTime() {
            let month = new Date().getMonth(); //返回当前月份     0-11 代表1-12月
            let twoMonthOld = month - 2; // 当前月份-2    两个月前的月份

            if (twoMonthOld < 0) {
                twoMonthOld += 12; //两个月之前的月份 比如当前是2月，2个月之前就是当前月份-2，当前月算一个月，所以减2
            }

            // console.log(twoMonthOld);

            let year = new Date().getFullYear(); //返回当前年份

            let twoMonthOldStr;

            if (twoMonthOld > month) {
                // 2个月前的月份大于现在的月份(去年)

                twoMonthOldStr = `${year - 1}/${twoMonthOld + 1}/1`;

                // console.log(new Date(twoMonthOldStr).getTime());
            } else {
                // 2个月前的月份不大于现在的月份(今年)
                twoMonthOldStr = `${year}/${twoMonthOld + 1}/1`;
            }

            let threeMonths = new Date(twoMonthOldStr).getTime();

            return threeMonths;
        },
        timeChange(val) {
            if (val != null) {
                _this.submit_data.fixed_array = JSON.stringify(['between'].concat(val));
            } else {
                _this.submit_data.fixed_array = '';
            }
            // 获取子组件的dom节点，直接改变子组件submit_data中fixed_array的值
            this.$refs.commonExport.$data.submit_data.fixed_array = this.submit_data.fixed_array;
            //  console.log(this.$refs.commonExport.$data.submit_data);
        },
        orderHis() {
            // console.log(this.$route.path);

            this.$router.push('/orderExport');
        },
          typeChange() {
            let type = '';
            // 获取子组件的dom节点，直接改变子组件submit_data中type的值
            switch (this.submit_data.type) {
                case '0':
                    type = '已支付订单';
                    break;
                case '2':
                    type = '全部订单';
                    break;
                case '4':
                    type = '销单订单';
                    break;
                case '6':
                    type = '三方无效销单';
            }
             // 获取子组件的dom节点，直接改变子组件submit_data中type的值 给导出的excel文件添加订单类型字段
             this.$refs.commonExport.$data.type = type;
            this.$refs.commonExport.$data.submit_data.type = _this.submit_data.type;




        },
        // yearChange(year) {
        //     console.log(year,'year');
        //     this.$refs.commonExport.$data.submit_data.year = year;
        //     console.log(this.$refs.commonExport.$data.submit_data.year,'this.$refs.commonExport.$data.submit_data.year');
        // }
         yearChange() {

            this.$refs.commonExport.$data.submit_data.year = this.submit_data.year;

        }
    }
};
</script>

<style scoped>
.box1 {
    height: 100% !important;
}

.handle-box-search.order .title {
    font-size: 14px;
    display: inline-block;
    width: 120px;
    text-align: right;
    margin-right: 5px;
    color: #747474;
}
.order-export-title {
    display: flex;
    width: 100%;
    height: 60px;
    line-height: 60px;
    padding-left: 20px;
    box-sizing: border-box;
    background-color: #f5f7fa;
}
.remark {
    font-size: 14px;
    margin-left: 10px;
    color: #c2c4c9;
}
.handle-box-search.order {
    background-color: #fff !important;
}
.year-button:first-child {
    margin-left: 10px;

}
</style>

<style>
.order-export-checkbox .el-checkbox__input {
    display: none !important;
}
</style>
